//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SubscribeFreeElements',
  props: {
    mediaType: {
      type: String,
      required: true,
    },
  },
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    GoogleRecaptchaText: () => import('@motionelements/core/src/components/auth/GoogleRecaptchaText.vue'),
    FreeEdmForm: () => import('@/components/free/FreeEdmForm.vue'),
  },
};
